import { RouterProvider } from "react-router-dom";
import { routers } from "./Routers";
import { RegistrationVerificationProvider } from "./register/registration-verification-context";
import { SocialModeProvider } from "./social-auth/social-mode-context";
import { OrToastContainer } from "./shared_modules/ui/components/atoms/or-toast/or-toast";

export function App() {
  return (
    <SocialModeProvider>
      <RegistrationVerificationProvider>
        <OrToastContainer />
        <RouterProvider router={routers} />
      </RegistrationVerificationProvider>
    </SocialModeProvider>
  );
}

export default App;
